import classNames from "classnames";
import { Select } from "PFComponents/select/select";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import useFiltersRange from "PFCore/hooks/use_filters_range";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./quick_date_filter.module.scss";

type QuickDateProps = {
  availabilityFilter: any;
  handleFilterChange: (filter: { name: string }, value: number | string | {} | null) => void;
  dateRangeMode: "past" | "future" | "all";
  className?: string;
};

const QuickDateFilter = ({
  availabilityFilter,
  handleFilterChange,
  dateRangeMode,
  className
}: QuickDateProps) => {
  const { t } = useTranslation("insights");
  const { pastOptions, futureOptions, allOptions } = useFiltersRange();
  const { formatDate } = useDateFormatter();
  const [selectedOption, setSelectedOption] = useState<string | undefined>(t("filters.custom"));

  const selectRenderer = (item, displayElement) => (
    <div>
      <div className={css.title}>{displayElement}</div>
      <div className={css.dates}>{`${formatDate(item.start)} - ${formatDate(item.end)}`}</div>
    </div>
  );

  // for supply we only want future options
  const selectedOptions = { past: pastOptions, future: futureOptions, all: allOptions }[dateRangeMode];

  useEffect(() => {
    const hasOptionsSelected = selectedOptions.find(
      (option) =>
        option.item.start === availabilityFilter?.value?.start &&
        option.item.end === availabilityFilter?.value?.end
    );

    setSelectedOption(hasOptionsSelected ? hasOptionsSelected.displayElement : t("filters.custom"));
  }, [availabilityFilter]);

  const options = useMemo(
    () => [
      ...selectedOptions.map((option, index) => ({
        id: option.id,
        item: {
          ...option.item,
          index: index + 1,
          value: option.displayElement
        },
        displayElement: selectRenderer(option.item, option.displayElement)
      }))
    ],
    [availabilityFilter]
  );

  return (
    <div className={classNames(css.wrapper, className)}>
      <label>{t("filters.quickDateFilter")}</label>
      <Select
        // @ts-ignore
        options={options}
        kind="bordered"
        value={selectedOption}
        controlledValue
        closeOnChange={false}
        handleChange={(date) => {
          handleFilterChange(availabilityFilter, date);
          setSelectedOption(options.find((option) => option.item.index === date.index)?.item.value);
        }}
      />
    </div>
  );
};

export default QuickDateFilter;
